import React, { useState, useRef } from "react";
import { useLocation } from "@reach/router";
import * as c from "./navbar.module.scss";
import { Link } from "gatsby";
import classNames from "classnames";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { trackEvent } from "@utils/analytics";
import { BREAKPOINTS } from "@utils/breakpoints";
import DesktopNavbarItems from "@components/navbar/desktop/desktopNavbarItems";
import MobileNavbarItems from "@components/navbar/mobile/mobileNavbarItems";
import HamburgerMenu from "@components/shared/hamburgerMenu";
import { Button } from "@components/shared";
import mangomintLogo from "@images/nav/mangomint-logo.svg";

export default function Navbar({ navColorVariant }) {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const isPricingRoute = location.pathname.startsWith("/pricing/");
  const isHomeRoute = location.pathname === "/";

  const toggleMobileNav = () => setMobileNavOpen(!isMobileNavOpen);
  const headerRef = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  useGSAP(
    () => {
      const isMobile = window.innerWidth < BREAKPOINTS.sm;
      const bannerHeight = isMobile ? 55 : 35;
      const offset = bannerHeight + 5;

      ScrollTrigger.create({
        start: `top 0%-=${offset}px`,
        end: "bottom bottom",
        onEnter: () => {
          headerRef.current.style.setProperty("--opacity", "1");
        },
        onLeaveBack: () => {
          headerRef.current.style.setProperty("--opacity", "0");
        },
      });
      ScrollTrigger.create({
        scroller: "#mobile-nav-list",
        trigger: "#mobile-nav-list", // Add shadow to mobile nav when scrolling
        start: "top 0%-=5px",
        end: "bottom bottom",
        onEnter: () => {
          headerRef.current.style.setProperty("--nav-opacity", "1");
        },
        onLeaveBack: () => {
          headerRef.current.style.setProperty("--nav-opacity", "0");
        },
      });
      ScrollTrigger.config({ ignoreMobileResize: true });
    },
    { scope: headerRef, dependencies: [headerRef.current] }
  );

  return (
    <>
      <header
        style={{ "--navColorVariant": navColorVariant }}
        ref={headerRef}
        className={classNames(c.header, {
          [c.mobileNavOpen]: isMobileNavOpen,
          [c.darkBackground]: navColorVariant === "cream-100",
        })}
      >
        <nav className={c.navbar}>
          <Link className={classNames(c.logo, isHomeRoute && "home-logo")} to="/">
            <img src={mangomintLogo} height="24" width="157" alt="Mangomint Logo" />
          </Link>
          <div className={c.rightnav}>
            <Button
              className={c.mobileBtn}
              linkTo={isPricingRoute ? "/demo/" : "/pricing/"}
              onClick={() =>
                trackEvent(isPricingRoute ? "Mobile Nav: Book demo CTA Clicked" : "Mobile Nav: Pricing CTA Clicked")
              }
            >
              {isPricingRoute ? "Book demo" : "See plans"}
            </Button>

            <HamburgerMenu isActive={isMobileNavOpen} toggleActive={toggleMobileNav} />
          </div>

          <DesktopNavbarItems />

          <MobileNavbarItems isMobileNavOpen={isMobileNavOpen} toggleMobileNav={toggleMobileNav} />
        </nav>
      </header>
    </>
  );
}
